/****************************************************
 * Module Name:  multipleUsersPermission.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState, useMemo } from "react";
import UserProxy from "../../utility/proxy/manager/userProxy";
import Select from "react-select";
import { Box, Typography } from "@mui/material";
import Constants from "../../utility/constants";
import DualListBox from "react-dual-listbox";
import UserPermissionProxy from "../../utility/proxy/manager/permissionProxy/userPermissionProxy";
import PermissionProxy from "../../utility/proxy/manager/permissionProxy/permissionProxy";
import "react-dual-listbox/lib/react-dual-listbox.css";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import BlockIcon from "@mui/icons-material/Block";
import AddTaskIcon from "@mui/icons-material/AddTask";
import Utility from "../../utility/utility";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import { LoadingButton } from "@mui/lab";

const fullPermissionValue = (users, permissions) => {
  let arr = [];
  if (permissions.value) {
    users.map((perm) => {
      arr.push({
        userid: perm.value,
        permissionid: permissions.sendValue,
        type: permissions.type,
      });
      return arr;
    });
  } else {
    permissions.map((perm) => {
      users.map((user) => {
        arr.push({
          userid: user.value,
          permissionid: perm.sendValue,
          type: perm.type,
        });
        return arr;
      });
      return arr;
    });
  }
  return arr;
};

const MultiplePermissions = () => {
  const [permission, setPermission] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [permissionOption, setPermissionOption] = useState([]);
  const [successSnackbar, setSuccessSnackbar] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [grantLoader, setGrantLoader] = useState(false);
  const [revokeLoader, setRevokeLoader] = useState(false);
  const [permissionInputValue, setPermissionInputValue] = useState("");
  const [debouncedPermissionInputValue, setDebouncedPermissionInputValue] = useState("");
  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid ===
        Constants.PERMISSIONS.PERMISSION_USERPERMISSION_PERMISSIONS
    )
  );

  useEffect(() => {
    getAllUser();
    getAllUserPermission();
  }, []);

  const onChange = (value) => {
    setSelected(value);
  };

  const getAllUser = () => {
    UserProxy.GetAllGenericUserMini((response) => {
      if (response) {
        setAllUserData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedPermissionInputValue(permissionInputValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [permissionInputValue]);

  const filteredPermissionOptions = useMemo(() => {
    if (!debouncedPermissionInputValue) {
      return permissionOption.slice(0, 100);
    }
    return permissionOption.filter(option =>
      option.label.toLowerCase().includes(debouncedPermissionInputValue.toLowerCase())
    ).slice(0, 500);
  }, [debouncedPermissionInputValue, permissionOption]);

  const setAllUserData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.username };
      optionsArray.push(option);
      return true;
    });
    setUserOptions(optionsArray);
  };

  const getAllUserPermission = () => {
    PermissionProxy.GetAllPermission((response) => {
      if (response) {
        setAllUserPermissionData(response)
      } else {
        setErrorSnackbar(true)
      }
    }
    );
  };

  const setAllUserPermissionData = (response) => {
    response.sort((a, b) => a.name.localeCompare(b.name));
    let optionsArray = [];
    let uniqueId = 0;
    response.map((option) => {
      Constants.PERMISSION_TYPE.map((permission) => {
        uniqueId++;
        let option1 = {
          value: uniqueId,
          label: option.name + " - " + permission,
          type: permission,
          sendValue: option.id,
        };
        uniqueId++;
        optionsArray.push(option1);
        return true;
      });
      return true;
    });
    setPermissionOption(optionsArray);
    setPermission(
      permission === "" && optionsArray.length > 0
        ? optionsArray[0]
        : permission
    );
  };

  const handleGrantPermission = () => {
    let data = fullPermissionValue(selected, permission);
    setGrantLoader(true);
    UserPermissionProxy.AddUserPermission(data, (response) => {
      if (response) {
        setSnackMessage(response);
        setSuccessSnackbar(true);
        setGrantLoader(false);
      } else {
        setErrorSnackbar(true);
        setGrantLoader(false);
      }
    });
  };

  const handleRevokePermission = () => {
    let data = fullPermissionValue(selected, permission);
    setRevokeLoader(true);
    UserPermissionProxy.DeleteUserPermission(data, (response) => {
      if (response) {
        setSnackMessage(response);
        setSuccessSnackbar(true);
        setRevokeLoader(false);
      } else {
        setErrorSnackbar(true);
        setRevokeLoader(false);
      }
    });
  };

  return (
    <Box>
      <TabMenuSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Error"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {successSnackbar ? (
        <TabMenuSnackbar
          show={true}
          message={<Box>{snackMessage.errorMessage}</Box>}
          variant={snackMessage.status.toLowerCase()}
          autoHide={snackMessage.status === "Success" ? true : false}
          handleClose={() => setSuccessSnackbar(false)}
          title={snackMessage.status}
        />
      ) : null}
      <Box
        sx={{
          display: "flex",
          minWidth: "350px",
          maxWidth: "auto",
          gap: "20px",
          mb: 1,
          px: 1
        }}
      >
        <Box sx={{ alignSelf: "center", mt: 2 }}>
          <Typography>Permissions</Typography>
        </Box>
        <Box
          sx={{
            alignSelf: "center",
            minWidth: "350px",
            maxWidth: "auto",
            mt: 2,
          }}
        >
          <Select menuPlacement="auto"
            blurInputOnSelect={false}
            menuPortalTarget={document.body}
            styles={Constants.Styles}
            isMulti
            closeMenuOnSelect={false}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            options={filteredPermissionOptions}
            value={permission}
            onChange={(e) => setPermission(e)}
            inputValue={permissionInputValue}
            onInputChange={(inputValue) => setPermissionInputValue(inputValue)}
          />
        </Box>
      </Box>
      <Box
        sx={{

          "& .rdl-controls": {
            minHeight: "550px",
            maxHeight: "700px",
          },
          backgroundColor: '#fff',
          color: '#000',
          height: '55vh',
          padding: 1
        }}
      >
        <DualListBox
          canFilter
          filterPlaceholder={"Search Permissions"}
          // showNoOptionsText
          showHeaderLabels
          simpleValue={false}
          options={userOptions}
          selected={selected}
          onChange={onChange}
          icons={{
            moveLeft: <KeyboardArrowLeftIcon />,
            moveAllLeft: <KeyboardDoubleArrowLeftIcon />,
            moveRight: <KeyboardArrowRightIcon />,
            moveAllRight: <KeyboardDoubleArrowRightIcon />,
            // moveDown: <span className="fa fa-chevron-down" />,
            // moveUp: <span className="fa fa-chevron-up" />,
            // moveTop: <span className="fa fa-double-angle-up" />,
            // moveBottom: <span className="fa fa-double-angle-down" />,
          }}
        />
      </Box>
      <Box
        sx={{
          backgroundColor: '#fff',
          color: '#000',
          paddingBottom: 5,
          paddingRight: 5
        }}
        height={'15vh'}
        display="flex"
        alignItems="end"
        justifyContent="end"
        gap={"15px"}
      >
        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isAddAllowed(local_Permission) ? (
          <LoadingButton
            variant="contained"
            startIcon={<AddTaskIcon />}
            loading={grantLoader}
            loadingPosition="start"
            onClick={handleGrantPermission}
            disabled={permissionOption.length === 0 || selected.length === 0 || revokeLoader}
          >
            Grant
          </LoadingButton>
        ) : null}

        {Utility.isUpdateAllowed(local_Permission) ||
          Utility.isDeleteAllowed(local_Permission) ? (
          <LoadingButton
            sx={{ bgcolor: "#1a237e" }}
            variant="contained"
            loading={revokeLoader}
            loadingPosition="start"
            component="label"
            startIcon={<BlockIcon />}
            onClick={handleRevokePermission}
            disabled={permissionOption.length === 0 || selected.length === 0 || grantLoader}
          >
            Revoke
          </LoadingButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default MultiplePermissions;
